import { render, staticRenderFns } from "./KarInterno.vue?vue&type=template&id=dbdc76fc&scoped=true"
import script from "./KarInterno.vue?vue&type=script&lang=js"
export * from "./KarInterno.vue?vue&type=script&lang=js"
import style0 from "./KarInterno.vue?vue&type=style&index=0&id=dbdc76fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdc76fc",
  null
  
)

export default component.exports